import React from "react";
import { forEach } from "lodash";

import { findEventTypeInTree } from "../../utils/event";
import { getAttributeValue } from "../../utils/profile";

import images from "../../assets/img/images";

const WearingMask = (props) => {
  const { humanIdentificationEventGroup } = props;
  const [isWearingMask, setIsWearingMask] = React.useState();

  React.useEffect(() => {
    const faceDetectionEvents = findEventTypeInTree(
      humanIdentificationEventGroup,
      [2]
    );

    let wearingMask;
    forEach(faceDetectionEvents, (e) => {
      if (getAttributeValue(e, 152) === true) {
        wearingMask = true;
      } else if (
        wearingMask === undefined &&
        getAttributeValue(e, 152) === false
      ) {
        wearingMask = false;
      }
    });
    setIsWearingMask(wearingMask);
  }, [humanIdentificationEventGroup]);

  return (
    <img
      src={
        isWearingMask === true
          ? images.maskGreen
          : isWearingMask === false
          ? images.noMaskRed
          : images.maskGrey
      }
      height={props.height || 25}
      alt="mask_status"
    />
  );
};

export default WearingMask;
